export default {
  nav: {
    home: 'Home',
    groupIntroduction: 'Group Introduction',
    portLogistics: 'Port Logistics',
    industrialBase: 'Industrial Park',
    characteristicTown: 'Characteristic Town',
    newsCenter: 'News Center',
    downloadCenter: 'Download Center',
    aboutUs: 'Contact Us',
  },
  footer: {
    linkTitle: 'Friendship Links',
    nav: {
      home: 'Home',
      about: 'Contact Us',
      recruit: 'Talent Recruitment',
      contact: 'Contact Us',
      message: 'Online Message',
      download: 'Download Center',
      rss: 'Subscribe RSS'
    },
    contact: {
      address: 'Address：',
      phone: 'Tel：',
      email: 'Email：',
      addressValue: "6/F, North Sea Commercial Building, 302 Queen's Road Central, Central, Hong Kong",
      phoneValue: '(+852)2139 5018',
      emailValue: 'chenxm@pntg.com.hk'
    },
    copyright: 'Copyright 2010-2016 PUTAI (HONG KONG) GROUP CO., LIMITED All Rights Reserved',
    record: 'ZheICP Bei 15012664-2',
  },
  friendLinks: {
    realEstate: 'China Real Estate Association',
    logistics: 'China Federation of Logistics and Purchasing',
    environmental: 'China Environmental Protection Industry Association',
    building: 'China Academy of Building Research',
    trade: 'China Council for the Promotion of International Trade',
    huzhou: 'Huzhou Economic Development Zone',
    haining: 'Haining Municipal Government Official Website',
    suzhou: 'Suzhou Municipal Bureau of Commerce',
    guangxi: 'Guangxi Investment Promotion Bureau',
    economy: 'China Economic Net',
    enterpriseNews: 'Enterprise News Network'
  },
  project: {
    mainTitle: 'Group Projects',
    subtitle: 'PUTAI Group has a diversified business layout, covering five major fields: logistics real estate, commercial real estate, environmental protection technology, engineering construction and commodity circulation',
    viewProject: 'View Project →',
    items: {
      logistics: {
        title: 'Logistics Real Estate',
        desc: 'Construction and operation management of modern intelligent logistics parks'
      },
      commercial: {
        title: 'Commercial Real Estate',
        desc: 'Development and project management of urban complexes and commercial supporting facilities'
      },
      environmental: {
        title: 'Environmental Protection Technology',
        desc: 'R&D and application promotion of green environmental protection technologies'
      },
      engineering: {
        title: 'Engineering Construction',
        desc: 'General contracting and management services for various engineering projects'
      },
      circulation: {
        title: 'Commodity Circulation',
        desc: 'High-quality commodity supply chain management services'
      }
    },
    ProjectClassification: 'ProjectClassification'
  },
  video: {
    mainTitle: 'Group Video Showcase',
    subtitle: 'Learn about PUTAI Group\'s development history, corporate culture and project achievements through videos',
    items: {
      promo2025: {
        title: 'PUTAI Group 2025 Annual Promo Video',
        desc: 'Explore PUTAI Group\'s development history, core businesses and future vision, and witness how we lead the industry through innovation and excellence.'
      },
      huzhouLogistics: {
        title: 'Huzhou Logistics Industrial Park Project Introduction',
        desc: 'Detailed introduction to the planning, design, construction progress and future operation mode of PUTAI Group\'s Huzhou Logistics Industrial Park.'
      },
      ecoTech: {
        title: 'PUTAI Environmental Protection Technology Business Showcase',
        desc: 'Showcase PUTAI Group\'s innovative achievements and sustainable development solutions in the field of environmental protection technology.'
      }
    }
  },
  filter: {
    filterByYear: 'Filter by Year', // 按年份筛选（英文）
    filterByType: 'Filter by Type',
    allNews: 'All News',    // 全部资讯（英文）
    allTypes: 'All Types',   // 全部类型（英文）
    yearSuffix: ''
  },
  downloadCenter: {
    dataCategory: 'Data Category', // 资料分类（英文通用表达）
    allData: 'All Materials',      // 全部资料（Materials更贴合“可下载资料”的语义）
    noDataTip: 'No downloadable materials in the current category' // 空数据提示
  },
  infoCards: {
    groupProfile: 'Group Profile',
    groupNews: 'Group News',
    downloadCenter: 'Download Center',
    moreNews: 'More News',
    moreFiles: 'More Files',
    groupName: 'Putai (Hong Kong) Group',
    groupDesc: 'Putai Group was co-founded by Mr. Cai Liangjun and Mr. Xuan Xiaofei in 2005. It is an investment group focusing on port logistics, industrial parks and other fields.<br><br>Putai is committed to becoming an influential industrial investment, development and operation enterprise in China, and has always advocated the development and application of ecological and environmental protection technologies...'
  },
  groupIntro: {
    imgDesc: 'Putai Group Port Logistics Industrial Park (Real Scene)',
    paragraph1: 'Putai (Hong Kong) Group Co., Ltd. is an investment group focusing on port logistics, logistics real estate and other fields.',
    paragraph2: 'While focusing on becoming the largest regional port logistics investment and development enterprise in mainland China and the most influential third-party logistics solution provider, Putai advocates the development and application of ecological and environmental protection technologies. "Low carbon, green and environmental protection" is the core concept advocated by Putai, and also Putai\'s core value.',
    paragraph3: 'Putai unremittingly builds green construction, takes environmental harmony as the foundation, optimizes the logistics chain, reduces logistics costs, improves logistics efficiency, reduces emissions, improves the environment, and is committed to becoming an industry innovator, leader and outstanding green enterprise, making the sky bluer and the water greener.',
    corePosition: 'Core Positioning',
    corePositionDesc: 'The largest regional port logistics investment and development enterprise in mainland China',
    serviceObjective: 'Service Objective',
    serviceObjectiveDesc: 'The most influential third-party logistics solution provider',
    devPhilosophy: 'Development Philosophy',
    devPhilosophyDesc: 'Green Construction, Environmental Harmony, Industry Innovation & Leadership'
  },
  portLogistics: {
    // 分类标签
    overview: 'Overview of Port & Shipping Logistics',
    jiaxing: 'Jiaxing Inland Port',
    deqing: 'Deqing Port',
    haining: 'Haining Port',

    // 港航物流概况
    overviewTitle: 'Overview of Port & Shipping Logistics',
    feature1: 'By investing in and constructing port logistics parks with functions of port loading/unloading, warehousing and distribution, market transactions and business supporting, we realize the modernization, standardization and intensification of transportation.',
    feature2: 'Relying on the convenience of "customs clearance integration" at ports, we enable inland cities to "connect rivers and seas" and enhance international competitiveness.',
    feature3: 'Relying on collection and distribution modes such as "sea-river intermodal transport, integrated vehicle-ship-port transport, and port-port linkage", we optimize the logistics chain, improve logistics efficiency and reduce logistics costs.',
    feature4: 'Through the business operation of "truck to water, bulk to container", we reduce carbon emissions and realize green and low-carbon transportation.',
    feature5: 'By integrating "human flow, logistics flow, capital flow and information flow", we integrate resources from all parties to form a capital highland and information center, and build a port-vicinity industrial agglomeration platform.',
    feature6: 'As a public service platform for regional geographical economy, relying on the convenience of economic integration, we serve the domestic and international dual circulation.',
    advantageTitle: 'Comprehensive Logistics Advantages',
    advantage1: 'Container Stuffing/Unstuffing & Warehousing',
    advantage2: 'Port & Logistics Finance',
    advantage3: 'Feeder Line Connecting to Mother Port',
    advantage4: 'Cold Storage & Cold Chain Distribution',

    // 嘉兴内河港
    jiaxingTitle: 'Jiaxing Inland Port · International Multi-purpose Port Area',
    jiaxingOverview: 'Located in Nanhu District, Jiaxing City, it is a key infrastructure project in Zhejiang Province and one of the major inland ports planned by the Ministry of Transport of the People\'s Republic of China.',
    jiaxingParam1: 'Total Floor Area: 326,000 square meters',
    jiaxingParam2: 'Berth Shoreline Length: 570 meters',
    jiaxingParam3: 'Designed Annual Throughput: 350,000 TEUs',
    jiaxingParam4: 'Current Annual Throughput: 220,000 TEUs',
    jiaxingFacilityTitle: 'Supporting Facilities:',
    jiaxingFacility1: 'Port Administration Authorities',
    jiaxingFacility2: 'Supporting Cargo Inspection and Fumigation',
    jiaxingFacility3: 'High-standard Warehouses',
    jiaxingFacility4: 'Cargo Inspection',
    jiaxingFacility5: 'Fumigation and Disinfection',
    jiaxingFacility6: 'Information Platform',
    jiaxingPosition: 'Committed to becoming a major distribution port providing comprehensive port functions and logistics services to support the construction of Shanghai International Shipping Center.',
    jiaxingImg1Alt: 'Jiaxing Inland Port Container Operation Area',
    jiaxingImg2Alt: 'Aerial View of Jiaxing Inland Port',
    jiaxingImg3Alt: 'Jiaxing Inland Port Customs Office Building',

    // 德清港
    deqingTitle: 'Deqing Port',
    deqingParam1: 'Shoreline Length: 510 meters',
    deqingParam2: '1000-ton Multi-purpose Berths: 7',
    deqingParam3: 'Annual Throughput: 3.5 million tons',
    deqingParam4: 'Container Throughput: 300,000 TEUs',
    deqingModeTitle: '"Vehicle-Ship-Port" Integrated Operation Mode',
    deqingModeDesc: 'Through inland waterways such as the Hangping-Shen Line, Hujia-Shen Line and Beijing-Hangzhou Grand Canal, containers can reach coastal ports such as Zhapu, Shanghai and Taicang within 18-28 hours, realizing sea-river intermodal transport and providing convenience for the import and export of bulk goods of enterprises in Deqing and surrounding areas.',
    deqingDevelopTitle: 'Development Achievements',
    deqingDevelopDesc1: 'Since its opening and operation on December 16, 2015, Deqing Port has pioneered and innovated, giving full play to the advantages of "land-sea-river intermodal transport, zone-port-park linkage, and vehicle-ship-port integration":',
    deqingDevelop1: 'By creating one-stop services such as warehousing, distribution, customs declaration, inspection and quarantine',
    deqingDevelop2: 'Making efforts in introducing shipping companies, opening new routes, expanding source market, and extending logistics services',
    deqingDevelop3: 'Activating vitality and laying a solid foundation for the development of inland container transportation',
    deqingDevelopDesc2: 'The throughput exceeded 100,000 TEUs in the following year, marking a new port era for Deqing.',
    deqingImg1Alt: 'Deqing Port Container Operation Area',
    deqingImg2Alt: 'Aerial View of Deqing Port Park',

    // 海宁港
    hainingTitle: 'Haining Port Logistics Park',
    hainingParam1: 'Total Investment: 250 million US dollars',
    hainingParam2: 'Total Floor Area: 550 mu (about 366,667 square meters)',
    hainingParam3: 'Shoreline Length: 386 meters',
    hainingParam4: '1000-ton Multi-purpose Berths: 8',
    hainingParam5: 'Annual Container Throughput: 300,000 TEUs',
    hainingFunctionTitle: 'Five Core Functions',
    hainingFunction1: 'Port',
    hainingFunction2: 'Container',
    hainingFunction3: 'Cold Chain & Warehousing',
    hainingFunction4: 'Commodity Trade',
    hainingFunction5: 'Information Platform',
    hainingQualificationTitle: 'Project Qualifications',
    hainingQualification1: 'Key Project of Zhejiang Province',
    hainingQualification2: 'Major Service Industry Project of Zhejiang Province',
    hainingQualification3: 'Major Construction Project of Zhejiang Province\'s 12th Five-Year Plan for Marine Economic Development',
    hainingImg1Alt: 'Haining Port Location and Transportation Map',
    hainingImg2Alt: 'Haining Port Regional Location Map',
    hainingImg3Alt: 'Haining Port Operation Area'
  },
  industrialBase: {
    // 通用标题/标签
    categoryTitle: 'Industrial Base',
    projectLocation: 'Project Location: ',
    trafficAdvantage: 'Traffic Advantages: ',
    coreParameters: 'Core Parameters: ',
    buildingFacilities: 'Building Facilities: ',
    keyIntroducedIndustries: 'Key Introduced Industries: ',
    benefitAfterCompletion: 'Benefits After Completion: ',
    carrierPositioning: 'Carrier Positioning: ',
    trafficLocationAdvantage: 'Traffic Location Advantages: ',
    industrialPositioning: 'Industrial Positioning: ',
    parkGoal: 'Park Goal: ',
    locationDistanceAdvantage: 'Location Distance Advantages: ',
    parkPositioning: 'Park Positioning: ',

    // 产业园名称
    suzhou: 'Keqi (Suzhou) Industrial Park',
    suzhouNewMaterial: 'Suzhou International New Material Industrial Park',
    xishan: 'Putai E-commerce Xishan Intelligent Manufacturing Base',
    bowang: 'Keqi (Bowang) Industrial Park',
    fangchenggang: 'Keqi (Fangchenggang) Industrial Park',

    // 科栖（苏州）产业园详情
    suzhouLocation: 'The project is located in Suzhou High-tech Zone and is one of the key industrial carriers in the region.',
    suzhouTraffic1: 'Wenchang Road Station of Metro Line 3 is within the industrial park',
    suzhouTraffic2: 'Adjacent to the Beijing-Hangzhou Grand Canal and Suzhou Middle Ring Road',
    suzhouTraffic3: 'Only two metro stops away from Suzhou New Area High-speed Railway Station, with extremely convenient transportation',
    suzhouParam1: 'Total Floor Area: 184 mu (≈122,667 ㎡)',
    suzhouParam2: 'Planned Construction Area: about 300,000 ㎡',
    suzhouParam3: 'Planned Total Investment: 1.5 billion RMB (developed in 3 phases)',
    suzhouParam4: 'Expected Introduced Enterprises: about 100 high-quality high-tech enterprises',
    suzhouParam5: 'Annual Tax Revenue After Completion: over 200 million RMB',
    suzhouImg1Alt: 'Location Map of Keqi (Suzhou) Industrial Park',
    suzhouImg2Alt: 'Overall Rendering of Keqi (Suzhou) Industrial Park',
    suzhouImg3Alt: 'Real Scene of Keqi (Suzhou) Industrial Park',
    suzhouImg4Alt: 'Building Appearance of Keqi (Suzhou) Industrial Park',

    // 苏州国际新材料产业园详情
    suzhouNewMaterialLocation: 'Located on Suhua Road, Suzhou High-tech Zone, it has become an important industrial undertaking carrier of Xushuguan Economic and Technological Development Zone.',
    suzhouNewMaterialParam1: 'Total Development Area: about 60 mu (≈40,000 ㎡)',
    suzhouNewMaterialParam2: 'Total Construction Area: 150,000 ㎡',
    suzhouNewMaterialFacilities: 'Mainly includes one Class A warehouse and two four-story high-standard Class C industrial facilities',
    suzhouNewMaterialIndustry1: 'Auto Parts',
    suzhouNewMaterialIndustry2: 'Intelligent Equipment Manufacturing',
    suzhouNewMaterialIndustry3: 'Semiconductor',
    suzhouNewMaterialIndustry4: 'Biomedicine',
    suzhouNewMaterialIndustry5: 'Medical Devices',
    suzhouNewMaterialIndustry6: 'New Materials',
    suzhouNewMaterialBenefit1: 'Expected increase in registered capital: over 500 million RMB',
    suzhouNewMaterialBenefit2: 'Annual output value: over 3 billion RMB',
    suzhouNewMaterialBenefit3: 'Annual tax payment: over 200 million RMB',
    suzhouNewMaterialBenefit4: 'Increase of more than 6 high-tech enterprises',
    suzhouNewMaterialImg1Alt: 'Overall Rendering of Suzhou International New Material Industrial Park',
    suzhouNewMaterialImg2Alt: 'Warehouse Scene of Suzhou International New Material Industrial Park',
    suzhouNewMaterialImg3Alt: 'Industrial Facility Appearance of Suzhou International New Material Industrial Park',

    // 普泰易商锡山智能制造基地详情
    xishanLocation: 'Located in Xishan Economic and Technological Development Zone, Wuxi City.',
    xishanParam1: 'Construction Land Area: about 93 mu (≈62,000 ㎡)',
    xishanParam2: 'Total Construction Area: 98,571 ㎡',
    xishanParam3: 'Construction Content: Production workshops and related supporting facilities',
    xishanParam4: 'Total Investment: about 150 million US dollars',
    xishanCarrierPosition: 'Xishan Intelligent Manufacturing Base is a high-standard carrier platform',
    xishanIndustry1: 'High-end Equipment Manufacturing',
    xishanIndustry2: 'Auto Parts',
    xishanIndustry3: 'Electronic Communication Equipment',
    xishanBenefit1: 'Expected Annual Output Value: nearly 1 billion RMB',
    xishanBenefit2: 'Expected Annual Tax Payment: nearly 47 million RMB',
    xishanBenefit3: 'Annual Comprehensive Tax: about 500,000 RMB per mu',
    xishanBenefit4: 'Planned Employment: over 1,000 people',
    xishanImg1Alt: 'Overall Rendering of Xishan Intelligent Manufacturing Base',
    xishanImg2Alt: 'Supporting Facilities of Xishan Intelligent Manufacturing Base',
    xishanImg3Alt: 'Building Appearance of Xishan Intelligent Manufacturing Base',

    // 科栖（博望）产业园详情
    bowangLocation: 'Located in Bowang District, Maanshan City, it is one of the core carriers of Bowang Modern Industrial Integration Demonstration Zone.',
    bowangParam1: 'Total Floor Area: 200 mu (≈133,333 ㎡)',
    bowangParam2: 'Total Project Investment: 1.2 billion RMB',
    bowangParam3: 'Phase I Floor Area: 100 mu (≈66,667 ㎡)',
    bowangParam4: 'Phase I Construction Area: about 55,000 ㎡',
    bowangParam5: 'Phase I Total Investment: 600 million RMB',
    bowangTraffic1: 'About 40KM from Maanshan Station',
    bowangTraffic2: 'About 30KM from Lukou Airport',
    bowangTraffic3: 'About 40KM from Lishui Station and 36KM from Dangtu East Station',
    bowangIndustrialPosition: 'Taking high-standard workshops as the carrier, focusing on equipment manufacturing, intelligent manufacturing, new-generation information technology, new materials and other industries.',
    bowangParkGoal: 'Committed to building Bowang Modern Industrial Integration Demonstration Zone, constructing a modern new industrial space, attracting and gathering a number of small and medium-sized enterprises with high growth potential, and becoming a new engine for Bowang\'s industrial upgrading and advancement.',
    bowangImg1Alt: 'Traffic Location Map of Keqi (Bowang) Industrial Park',
    bowangImg2Alt: 'Planning Map of Keqi (Bowang) Industrial Park',
    bowangImg3Alt: 'Workshop Rendering of Keqi (Bowang) Industrial Park',

    // 科栖（防城港）产业园详情
    fangchenggangLocation: 'Located in the east of Fangchenggang City, adjacent to Fangchenggang Port, it is the core carrier of the new micro-enterprise center in Fangchenggang City.',
    fangchenggangDistance1: '10.9 km from Fangchenggang urban area',
    fangchenggangDistance2: '15.1 km from Fangchenggang Port',
    fangchenggangParam1: 'Total Floor Area: 111 mu (≈74,000 ㎡)',
    fangchenggangParam2: 'Planned Construction Area: about 66,000 ㎡',
    fangchenggangParam3: 'Total Investment: 220 million RMB',
    fangchenggangParkPosition: 'Build a comprehensive production base-type park integrating production, display, business and office, shape a new image of Fangchenggang Industrial Park, construct a standardized, professional and clustered production park, and become the new micro-enterprise center of Fangchenggang City.',
    fangchenggangImg1Alt: 'Location Map of Keqi (Fangchenggang) Industrial Park'
  },
  characteristicTown: {
    // 通用标题/标签
    categoryTitle: 'Characteristic Town',
    projectLocation: 'Project Location: ',
    projectOverview: 'Project Overview: ',
    surroundingEcologicalEnvironment: 'Surrounding Ecological Environment: ',
    planningMapAlt: 'Planning Map of Xushuguan Green Technology Town',

    // 浒墅关特色小镇相关
    xushuguan: 'Xushuguan Characteristic Town',
    xushuguanGreenTechTown: 'Xushuguan Green Technology Town',
    xushuguanLocationDesc: 'Located in the core area of Xushuguan Economic and Technological Development Zone, Suzhou High-tech Zone. The town boundaries are: ',
    eastTo: 'East to: Suhu Road',
    southTo: 'South to: National Highway 312 - Dahe New River',
    westTo: 'West to: National Highway 312 - Wenchang Road',
    northTo: 'North to: Tonghu Road',
    xushuguanOverviewDesc: 'Jointly built by Putai Group and the Management Committee of Xushuguan Economic and Technological Development Zone',
    planningArea: 'Planning Area: 3.4 square kilometers',
    constructionLandArea: 'Construction Land Area: about 2100 mu (≈1.4 square kilometers)',
    totalInvestment: 'Total Investment: 35 billion RMB',

    // 上城·浒关运河文化古镇
    upperTown: 'Upper Town · Xushuguan Canal Culture Ancient Town',
    upperTownDesc: 'Promote urban renewal, form the northwest gateway of Suzhou city, and become a new cultural and leisure landmark of Suzhou and a model for the cultural rejuvenation of the Grand Canal of China',
    upperTownInvestment: 'Total Investment: about 16 billion RMB',

    // 下城·绿色产业新城
    lowerTown: 'Lower Town · Green Industry New Town',
    lowerTownDesc: 'Introduce the concept of UNIDO Green Industrial Park, focus on the new generation of information technology, intelligent manufacturing, medical devices, 5G industry, and build an industrial new town with the concept of Industry 4.0',
    lowerTownInvestment: 'Total Investment: about 19 billion RMB',

    // 周边生态环境
    ecologicalEnv1: '7 kilometers to the east is the Huqiu Wetland Park, a green lung in northern Suzhou covering nearly 20,000 mu (≈13.3 square kilometers)',
    ecologicalEnv2: '4 kilometers to the west is Jiangsu Dayangshan National Forest Park, 13 kilometers west of Taihu Lake, which is an important node on Suzhou\'s major ecological leisure route'
  },
  common: {
    backHome: 'back to home',
    backList: 'back to list'
  }
}